import React from "react";

import { QRFRameProps } from "../types";

import { getPreviewFrameFontSize } from "@/utils/qrEditorHelper";
import "../styles.scss";

export const hairsalonFrame = (
  props: Omit<QRFRameProps, "frameType">
): React.SVGProps<SVGSVGElement> => {
  const { text, textColor, children, frameColor, frameBackgroundColor, urlQr } = props;

  const fontSize = getPreviewFrameFontSize(text?.length);

  return (
    <svg
      width="96"
      height="128"
      viewBox="0 0 96 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.5"
        y="0.5"
        width="95"
        height="127"
        rx="7.5"
        fill="white"
      />
      <rect
        x="0.5"
        y="0.5"
        width="95"
        height="127"
        rx="7.5"
        stroke="#BFBFBF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M41.3839 26.941C40.54 26.5029 39.5343 27.3534 38.889 28.3634C38.6613 28.7541 38.6842 29.2005 39.0982 29.765C40.5075 31.6842 43.5769 28.0324 41.3839 26.941ZM46.0289 20.5604L45.9779 20.6588C45.5151 21.7717 45.1469 22.6635 44.8735 23.3342C43.8076 25.0328 43.2677 25.9472 42.3921 26.132C42.0444 26.2207 41.726 26.2391 41.4366 26.189C40.0352 26.0138 38.8193 26.9254 38.2865 28.2153C37.9666 28.9908 38.221 29.7852 38.802 30.3709C39.267 30.8393 39.925 31.0636 40.5794 30.9767C41.3163 30.7437 41.6171 30.4665 42.1403 30.6287C42.1855 30.6347 42.2308 30.6196 42.2648 30.5897C42.2817 30.7188 42.3558 30.8112 42.5162 30.8554C42.6772 30.8995 42.8186 30.8103 42.9154 30.6747C43.0434 30.4964 42.9285 30.2849 42.7812 30.1957C42.7277 30.1635 42.6573 30.147 42.5664 30.169C42.6045 30.0491 42.5855 29.9562 42.5097 29.8909C42.3524 29.6215 42.4056 29.2276 42.5087 28.9458C43.2984 26.964 43.4551 26.3517 45.5669 24.3718C46.2964 24.0279 46.7382 23.7682 46.8913 23.5921C47.0182 23.4772 47.1184 23.36 47.1915 23.2405C47.1657 23.189 47.1437 23.1361 47.1253 23.0814C46.7584 22.2916 46.4109 21.4927 46.0854 20.6905L46.0289 20.5604ZM51.93 9.44536C51.9356 9.53914 51.879 9.72072 51.6708 10.1767C50.4383 13.0025 49.1535 15.7239 47.8259 18.3217C47.7426 18.1406 47.6843 18.0187 47.5946 17.8528C47.5946 17.8528 49.0096 15.0459 51.93 9.44536ZM53.208 26.941C51.0152 28.0324 54.0842 31.6842 55.4941 29.765C55.9078 29.2005 55.9308 28.7541 55.7028 28.3634C55.0578 27.3534 54.0525 26.5029 53.208 26.941ZM42.7066 9.44536C42.7009 9.53914 42.7573 9.72072 42.9657 10.1767C44.198 13.0025 45.4826 15.7239 46.8104 18.3217C46.8936 18.1406 46.9524 18.0187 47.0421 17.8528C47.0421 17.8528 45.6269 15.0459 42.7066 9.44536ZM46.9501 20.908C46.7635 20.7917 46.6398 20.5852 46.6398 20.3499C46.6398 19.9872 46.9336 19.6934 47.2963 19.6934C47.3367 19.6934 47.3763 19.6971 47.4144 19.704L46.9501 20.908ZM47.2963 21.0063C47.2554 21.0063 47.2158 21.0027 47.1777 20.9953L47.642 19.7918C47.8281 19.9076 47.9527 20.1141 47.9527 20.3499C47.9527 20.7126 47.6585 21.0063 47.2963 21.0063ZM42.4219 9.26378C42.4697 9.19896 42.5358 9.14977 42.6117 9.12219C44.9332 13.2742 46.598 16.436 47.6061 18.6067C47.927 19.2981 48.2635 19.9821 48.6142 20.6588C49.0772 21.7717 49.4454 22.6635 49.7184 23.3342C50.7845 25.0328 51.3246 25.9472 52.1999 26.132C52.5479 26.2207 52.8665 26.2391 53.1556 26.189C54.5568 26.0138 55.7727 26.9254 56.3055 28.2153C56.6254 28.9908 56.3712 29.7852 55.7901 30.3709C55.7244 30.4371 55.6545 30.4987 55.5814 30.5543C55.5088 30.6623 55.4297 30.7713 55.3442 30.8811C55.1213 31.4259 55.3769 31.8405 56.1105 32.1241C56.3404 32.2464 56.7118 32.343 57.2249 32.4142C57.4074 32.4372 57.5411 32.4731 57.6248 32.5232C57.6818 32.554 57.719 32.6137 57.7232 32.6813C57.7273 32.7484 57.6974 32.8128 57.645 32.8509C56.8337 32.9898 55.7322 32.5898 54.3402 31.6507C53.836 31.3312 53.4089 30.9349 53.0586 30.4623C52.6173 30.1061 52.3249 29.6174 52.0983 28.9867L52.0937 28.9734L52.0836 28.9458C51.2938 26.964 51.1371 26.3517 49.0252 24.3718C48.2957 24.0279 47.8539 23.7682 47.7008 23.5921C47.4939 23.405 47.3593 23.2124 47.2963 23.0143C46.929 22.2236 46.5814 21.4242 46.2532 20.617C45.0066 17.7792 43.7558 14.1757 42.5009 9.80485C42.3975 9.51799 42.371 9.33779 42.4219 9.26378ZM52.17 9.26378C52.1222 9.19896 52.0565 9.14977 51.9806 9.12219C49.9515 12.7511 48.4239 15.6233 47.3983 17.7388C47.5247 18.0017 47.6498 18.2651 47.7725 18.5295C48.0221 19.0678 48.2814 19.6015 48.5494 20.1306C49.7262 17.371 50.9072 13.9297 52.0909 9.80485C52.1948 9.51799 52.221 9.33779 52.17 9.26378Z"
        fill={frameColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M32.5234 28.236L32.9016 29.2124L33.9468 29.2703L33.1354 29.9319L33.4031 30.9441L32.5232 30.3764L31.6435 30.9441L31.9112 29.9319L31.0998 29.2703L32.1451 29.2124L32.5234 28.236Z"
        fill={frameColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M63.4837 28.236L63.862 29.2124L64.9073 29.2703L64.0955 29.9319L64.3635 30.9441L63.4837 30.3764L62.6038 30.9441L62.8718 29.9319L62.0604 29.2703L63.1053 29.2124L63.4837 28.236Z"
        fill={frameColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25.6907 28.9269C23.5627 30.5083 14.6296 31.8175 15.2938 28.0714C15.431 27.2969 16.0239 26.7287 16.6259 27.1654C16.2612 27.3709 16.502 27.8067 16.6806 27.82C16.904 27.8581 17.0669 27.7501 17.1248 27.4633C17.37 26.2501 14.73 25.704 14.8323 28.7592C14.956 32.4404 23.5896 30.7772 25.6907 28.9269ZM14 30.8269C27.1606 35.04 29.1538 22.7017 39.4789 25.173C37.759 25.385 36.3108 26.56 35.7485 28.1988C35.1858 29.8381 35.6079 31.6543 36.8355 32.8776C35.6155 32.1678 34.8135 30.9124 34.6824 29.5071C34.5512 28.1022 35.107 26.7199 36.1744 25.7969C28.7034 26.6859 25.8745 35.7636 14 30.8269Z"
        fill={frameColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M70.3093 28.9269C72.4373 30.5083 81.3704 31.8175 80.7062 28.0714C80.569 27.2969 79.9761 26.7287 79.3741 27.1654C79.7388 27.3709 79.498 27.8067 79.3194 27.82C79.096 27.8581 78.9331 27.7501 78.8752 27.4633C78.63 26.2501 81.27 25.704 81.1677 28.7592C81.044 32.4404 72.4104 30.7772 70.3093 28.9269ZM82 30.8269C68.8394 35.04 66.8462 22.7017 56.521 25.173C58.241 25.385 59.6892 26.56 60.2515 28.1988C60.8142 29.8381 60.3921 31.6543 59.1645 32.8776C60.3845 32.1678 61.1865 30.9124 61.3176 29.5071C61.4488 28.1022 60.893 26.7199 59.8256 25.7969C67.2966 26.6859 70.1255 35.7636 82 30.8269Z"
        fill={frameColor}
      />
      <rect
        x="18"
        y="37"
        width="60"
        height="60"
        rx="2"
        fill={frameBackgroundColor}
      />

      <foreignObject
        width="65%"
        height="65px"
        style={{ borderRadius: "3px" }}
        x="17"
        y="36">
        <div
          id="#qrCode"
          style={{
            border: `1px solid ${frameBackgroundColor || "white"}`,
            width: "100%",
            height: "100%",
            boxSizing: "border-box",
            padding: "3px",
            backgroundColor: `${frameBackgroundColor}`,
            paddingTop: "5px",
          }}>
          {urlQr ? (
            <img
              src={urlQr}
              width="100%"
              height="auto"
            />
          ) : (
            children
          )}
        </div>
      </foreignObject>
      <foreignObject
        width="100%"
        height="18px"
        y="102">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{ width: "100%", height: "100%", maxWidth: "100%" }}>
          <text
            x="50%"
            y="11"
            fill={textColor}
            dominantBaseline="middle"
            textAnchor="middle"
            fontFamily="sans-serif"
            fontWeight="bold"
            style={{ fontSize }}>
            {text}
          </text>
        </svg>
      </foreignObject>
    </svg>
  );
};
